import React, { useState } from 'react';
import classes from "../styles/style.module.css"
import { IoCloudUploadOutline } from "react-icons/io5";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { toast } from "react-hot-toast";
import { baseURL } from '../../../assets/constants/baseUrl';
import errorHandler from '../../../assets/utils/ErrorHandler';

const HubbleFileUploader = ({ file: uploadedFile, setFile: setUploadedFile }) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => handleFileUpload(acceptedFiles),
    maxFiles: 1,
    accept: {
      "audio/mpeg": [".mp3"],
      "audio/wav": [".wav"],
      "audio/webm": [".webm"],
      "audio/flac": [".flac"],
      "audio/x-m4a": [".m4a"],

      "video/mp4": [".mp4"],
      "video/mpeg": [".mpeg"],
      "video/webm": [".webm"],
    },
    onDropRejected: () => toast.error("لطفاً فقط یک فایل بارگذاری کنید."),
  });


  const handleFileUpload = async (files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file);
    });
    try {
      setLoading(true);
      const response = await axios.post(
        `${baseURL}file/upload/user?hubbleFormLevel=Level1`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("UserToken")}`,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          },
        }
      );

      setUploadedFile(response.data.file);
      toast.success("فایل با موفقیت بارگذاری شد.");
    } catch (error) {
      errorHandler(error);
      setProgress(0);
    } finally {
      setLoading(false);
      setProgress(0);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setUploadedFile(null);
  };

  return (
    <div className={classes.fileUploaderContiner} {...getRootProps()}>
      <input {...getInputProps()}  />
      {uploadedFile ? (
        <div className={classes.filePreviewWrapper}>
          {uploadedFile.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i) ? (
            <img
              src={`${baseURL}file/get/${uploadedFile}`}
              alt="Uploaded preview"
              className={classes.imagePreview}
            />
          ) : (
            <p className={classes.fileName}>
              {uploadedFile.replace(/^http.*\/file\/get\//, '')}
            </p>
          )}
          <button
            type="button"
            className={classes.removeButton}
            onClick={handleRemove}
          >
            حذف
          </button>
        </div>
      ) : (
        <>
          <IoCloudUploadOutline size={60} />
          <div>
            {loading
              ? `در حال بارگذاری: ${progress}%`
              : "بارگزاری ویدئو اثر  شما"}
          </div>
        </>
      )}
    </div>
  )
}

export default HubbleFileUploader